import { render, staticRenderFns } from "./ProfileImageCrop.vue?vue&type=template&id=528abb7c&scoped=true&"
import script from "./ProfileImageCrop.vue?vue&type=script&lang=js&"
export * from "./ProfileImageCrop.vue?vue&type=script&lang=js&"
import style0 from "./ProfileImageCrop.vue?vue&type=style&index=0&id=528abb7c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528abb7c",
  null
  
)

export default component.exports